export const AMOUNTS_FORMATTING_FEATURE_FLAG = 'highlight-amounts-formatting'
